import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, tap, map, catchError, of } from "rxjs";
import { environment } from "../../../environments/environment";
import { BoCredentials } from "../../models/BoCredentials";


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private readonly loginUrl = '/api/login/authenticate';
    private readonly logoutUrl = '/api/login/logout';
    private readonly checkAuthUrl = '/api/login/checkAuth';

    private targetUrl?: string;

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) { }

    public redirectToApplication() {
        this.targetUrl = this.activatedRoute.snapshot.queryParams["url"];

        if (this.targetUrl) {
            if (!this.targetUrl.includes('localhost'))
                this.targetUrl = `https://${this.targetUrl}`;
            else
                this.targetUrl = `http://${this.targetUrl}`;
        }
        else {
            this.targetUrl = environment.sistemasUrl;
        }

        location.href = this.targetUrl;
    }

    public login(boCredentials: BoCredentials): Observable<any> {
      return this.httpClient.post<string>(this.loginUrl, boCredentials);
    }

    public logout(): void {
        this.httpClient.post(this.logoutUrl, {}, { withCredentials: true }).subscribe(() => {
            this.router.navigate(['/login']);
        });
    }

    public isAuthenticated(): Observable<boolean> {
        return this.httpClient.get<boolean>(this.checkAuthUrl, { withCredentials: true }).pipe(
            map(response => response),
            catchError(() => of(false))
        );
    }
}